import { render, staticRenderFns } from "./IncOrderPaymentStatus.vue?vue&type=template&id=0d035f26"
import script from "./IncOrderPaymentStatus.vue?vue&type=script&lang=js"
export * from "./IncOrderPaymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports